import React, { useCallback, useState } from 'react';
import { useTranslation } from 'localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import SimpleTable, { RowSelection } from 'components/Common/SimpleTable/SimpleTable';
import { confirmButtons } from './ModalButtons';
import styles from './SelectedResourcesModal.module.css';

const SelectDashboardsModal = ({ title, tableColumns, isOpen, onClose, onSelected, available, selected: selectedIn, globalActions, actions }) => {
  const T = useTranslation();
  const [_selected, setSelected] = useState(null);

  const selected = _selected ?? selectedIn;

  const onConfirm = useCallback(() => {
    onSelected(selected);
    setSelected(null);
    onClose();
  }, [onSelected, selected, onClose]);

  const _onClose = useCallback(() => {
    setSelected(null);
    onClose();
  }, [onClose]);

  return (
    <Modal
      variant={ModalVariant.medium}
      className={styles.selectionModal}
      title={title}
      isOpen={isOpen}
      onClose={_onClose}
      actions={confirmButtons({ T, onConfirm: onConfirm, onCancel: _onClose })}
    >
      <SimpleTable
        globalActions={globalActions}
        actions={actions}
        data={available}
        columns={tableColumns}
        rowSelection={RowSelection.MULTI_CHECKBOX}
        selectedRows={selected}
        onSelectedRows={setSelected}
      />
    </Modal>
  );
};

export default SelectDashboardsModal;
